import React from "react";
import { useTheme } from "@mui/material/styles";
import ContentContainer from "../../components/common/ContentContainer";
import MemberEntry from "../../components/common/MemberEntry";
import { Typography, Grid, Box, Avatar, Chip } from "@mui/material";

const ProjectDetails = ({
  concept,
  goal,
  currentsystem,
  members,
  technologies,
}) => {
  const theme = useTheme();

  // Format members data for display
  const formattedMembers = typeof members === 'number' 
    ? Array(members).fill().map((_, i) => ({ name: `Team Member ${i+1}`, role: 'Contributor' }))
    : Array.isArray(members) 
      ? members 
      : [];

  // Ensure technologies is an array
  const formattedTechnologies = Array.isArray(technologies) 
    ? technologies 
    : technologies ? [technologies] : [];

  return (
    <Grid
      container
      id="project-details"
      sx={{ px: { xs: "1em", md: "4.25em" } }}
      spacing={4}
    >
      <Grid item xs={12} md={8}>
        <ContentContainer
          sx={{
            minHeight: "600px",
            "& .MuiTypography-h2, .MuiTypography-body1": {
              mb: "0.75em",
            },
          }}
        >
          <Typography variant="h2">Project Details</Typography>
          <Typography variant="h6">Concept</Typography>
          <Typography variant="body1">{concept}</Typography>
          <Typography variant="h6">Goal</Typography>
          <Typography variant="body1">{goal}</Typography>
          <Typography variant="h6">Current System</Typography>
          <Typography variant="body1">{currentsystem}</Typography>
          <Typography variant="h5" sx={{ color: "rgba(255, 255, 255, 0.6)" }}>
            Technologies Used
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {formattedTechnologies.length > 0 ? (
              formattedTechnologies.map((tech) => (
                <Chip
                  sx={{ mt: "0.625em", mr: "1.55em" }}
                  label={tech}
                  key={tech}
                />
              ))
            ) : (
              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                No technologies specified
              </Typography>
            )}
          </Box>
        </ContentContainer>
      </Grid>
      <Grid item xs={12} md={4}>
        <Box
          sx={{
            height: "600px",
            position: "relative",
            overflow: "hidden",
            // concerning 900px screen sizes and smaller
            display: "block",
            mx: "auto",
          }}
        >
          <ContentContainer
            sx={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right:
                "-15px" /* Increase/Decrease this value for cross-browser compatibility */,
              overflowY: "scroll",
            }}
          >
            <Typography variant="h2" sx={{ mb: "0.75em" }}>
              Members
            </Typography>
            <Box>
              {formattedMembers.length > 0 ? (
                formattedMembers.map(({ name, role }, index) => (
                  <MemberEntry name={name} role={role} key={index} />
                ))
              ) : (
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                  No team members listed
                </Typography>
              )}
            </Box>
          </ContentContainer>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProjectDetails;
